import { create } from 'zustand'

type CurrentRecordingTTL = {
    value: number
    updatedAt: number // we want to update CurrentRecordingTTL as an object as there are components that depend on it
}

export interface AudioBatch {
    id: number
    blob: Blob
    mimeType: string
    createdAt: number
}

interface AudioState {
    mediaRecorder: MediaRecorder | undefined
    currentRecordingTTL: CurrentRecordingTTL | undefined
    selectedMicrophoneDeviceId: string | undefined
    audioBatches: AudioBatch[]
}

const SELECTED_MICROPHONE_KEY = 'selectedMicrophoneDeviceId'

export const useAudioStore = create<AudioState>(() => ({
    mediaRecorder: undefined,
    currentRecordingTTL: undefined,
    selectedMicrophoneDeviceId: localStorage.getItem(SELECTED_MICROPHONE_KEY) || undefined,
    audioBatches: [],
}))

/** Persisted, so the choice survives a reload. */
export function setSelectedMicrophone(deviceId: string | undefined): void {
    useAudioStore.setState({ selectedMicrophoneDeviceId: deviceId })
    if (deviceId) {
        localStorage.setItem(SELECTED_MICROPHONE_KEY, deviceId)
    } else {
        localStorage.removeItem(SELECTED_MICROPHONE_KEY)
    }
}
